<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left">
        <img src="../assets/img/返回箭头.png" class="nav-img" @click="back()" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">排行榜</div>
      <div class="nav-right">
        <span class="nav-lable" @click="rules()">规则</span>
        <img src="../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>

    <div class="rules" ></div>

    <div class="content">
      <div class="ub ub-ac ub-pc up-name">
        <span v-if="sort_1==2" class="rank-1 rank-1-on" @click="sort1(2)">魅力榜</span>
        <span v-if="sort_1!=2" class="rank-1" @click="sort1(2)">魅力榜</span>

        <span v-if="sort_1!=1" class="rank-3" @click="sort1(1)">豪气榜</span>
        <span v-if="sort_1==1" class="rank-3 rank-1-on" @click="sort1(1)">豪气榜</span>
      </div>

      <div class="ub ub-ac ub-pc">
        <ul class="list rank-2 ub">
          <li v-if="sort_2!=1" @click="sort2(1)">今日榜</li>
          <li v-if="sort_2==1" class="on" @click="sort2(1)">今日榜</li>

          <li v-if="sort_2!=2" @click="sort2(2)">昨日榜</li>
          <li v-if="sort_2==2" class="on" @click="sort2(2)">昨日榜</li>

          <li v-if="sort_2!=3" @click="sort2(3)">周榜</li>
          <li v-if="sort_2==3" class="on" @click="sort2(3)">周榜</li>

          <li v-if="sort_2!=4" @click="sort2(4)">月榜</li>
          <li v-if="sort_2==4" class="on" @click="sort2(4)">月榜</li>
        </ul>
      </div>

      <li v-for="(item, index) in ary" :key="index">
        <div v-if="item.xh==1">
          <div class="ub ub-pc first">
            <div class="one-img">
              <img src="../assets/img/one.png" class="ranking-img" />
            </div>

            <div class="ub ub-pc ub-f1 ub-ver" @click="goto_topic(item)">
              <div class="ub ub-ac box">
                <img :src="item.photo2" />
              </div>

              <span class="nick">{{item.nick}}</span>
              <span v-if="sort_1==1" class="Howe">豪气值:{{item.c}}</span>
              <span v-if="sort_1==2" class="Howe">魅力值:{{item.c}}</span>
              <span v-if="sort_1==2 && sort_2==1" class="reward">预计奖励:{{Math.floor(item.c*0.3)}}(30%)</span>
              <span v-if="sort_1==2 && sort_2==2 && !item.c2" class="reward">等待奖励:{{Math.floor(item.c*0.3)}}(30%)</span>
              <span v-if="sort_1==2 && sort_2==2 && item.c2" class="reward">包含奖励:{{item.c2}}(30%)</span>
            </div>

            <div class="one-img"></div>
          </div>
          <div class="menu-line"></div>
        </div>

        <div v-else>
          <div class="ub ub-pc" @click="goto_topic(item)">
            <img v-if="item.xh==2" src="../assets/img/two.png" class="ranking-img" />
            <img v-if="item.xh==3" src="../assets/img/three.png" class="ranking-img" />
            <span v-if="item.xh>3" class="number">{{item.xh}}</span>

            <div class="ub ub-pc pic-nick">
              <img :src="item.photo2" class="pic" />
              <span>{{item.nick}}</span>
            </div>

            <div class="ub ub-f1 ub-ver ub-ae num">
              <span v-if="sort_1==1" class="ub ub-f1 ub-ae num">豪气值:{{item.c}}</span>
              <span v-if="sort_1==2" class="ub ub-f1 ub-ae num">魅力值:{{item.c}}</span>

              <div v-if="sort_1==2 && sort_2==1" class="ub ub-f1 ub-ver ub-ae num">
                <span v-if="item.xh==2" class="reward2">预计奖励:{{Math.floor(item.c*0.2)}}(20%)</span>
                <span v-if="item.xh==3" class="reward2">预计奖励:{{Math.floor(item.c*0.18)}}(18%)</span>
                <span v-if="item.xh==4" class="reward2">预计奖励:{{Math.floor(item.c*0.15)}}(15%)</span>
                <span v-if="item.xh==5" class="reward2">预计奖励:{{Math.floor(item.c*0.1)}}(10%)</span>
                <span v-if="item.xh==6" class="reward2">预计奖励:{{Math.floor(item.c*0.08)}}(8%)</span>
                <span v-if="item.xh==7" class="reward2">预计奖励:{{Math.floor(item.c*0.06)}}(6%)</span>
                <span v-if="item.xh==8" class="reward2">预计奖励:{{Math.floor(item.c*0.05)}}(5%)</span>
              </div>

              <div v-if="sort_1==2 && sort_2==2 && !item.c2" class="ub ub-f1 ub-ver ub-ae num">
                <span v-if="item.xh==2" class="reward2">等待奖励:{{Math.floor(item.c*0.2)}}(20%)</span>
                <span v-if="item.xh==3" class="reward2">等待奖励:{{Math.floor(item.c*0.18)}}(18%)</span>
                <span v-if="item.xh==4" class="reward2">等待奖励:{{Math.floor(item.c*0.15)}}(15%)</span>
                <span v-if="item.xh==5" class="reward2">等待奖励:{{Math.floor(item.c*0.1)}}(10%)</span>
                <span v-if="item.xh==6" class="reward2">等待奖励:{{Math.floor(item.c*0.08)}}(8%)</span>
                <span v-if="item.xh==7" class="reward2">等待奖励:{{Math.floor(item.c*0.06)}}(6%)</span>
                <span v-if="item.xh==8" class="reward2">等待奖励:{{Math.floor(item.c*0.05)}}(5%)</span>
              </div>

              <div v-if="sort_1==2 && sort_2==2 && item.c2" class="ub ub-f1 ub-ver ub-ae num">
                <span v-if="item.xh==2" class="reward2">包含奖励:{{item.c2}}(20%)</span>
                <span v-if="item.xh==3" class="reward2">包含奖励:{{item.c2}}(18%)</span>
                <span v-if="item.xh==4" class="reward2">包含奖励:{{item.c2}}(15%)</span>
                <span v-if="item.xh==5" class="reward2">包含奖励:{{item.c2}}(10%)</span>
                <span v-if="item.xh==6" class="reward2">包含奖励:{{item.c2}}(8%)</span>
                <span v-if="item.xh==7" class="reward2">包含奖励:{{item.c2}}(6%)</span>
                <span v-if="item.xh==8" class="reward2">包含奖励:{{item.c2}}(5%)</span>
              </div>

            </div>
          </div>
          <div class="menu-line"></div>
        </div>
      </li>
    </div>
    <alert ref="myConfirm" ></alert>
  </div>
</template>

<script>
import Alert from "../components/Form.vue";
import { mapMutations, mapActions } from "vuex";
import * as tool from "../api/common";
export default {
  components: {
    alert: Alert
  },
  data() {
    return {
      sort_1: 2,
      sort_2: 1,
      ary: [
        {
          xh: 1,
          photo: "",
          nick: "superman",
          sex: "男生",
          c: 222
        }
      ],
      theme_dark: false
    };
  },

  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    //解析参数
    this.init();
  },

  methods: {
    ...mapMutations(["get", "post"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },

    init() {
      if (this.$route.params.s1) {
        this.sort_1 = this.$route.params.s1;
        this.sort_2 = this.$route.params.s2;
      } else {
        var s1s2 = this.$store.state.rank_s1s2;
        if (s1s2) {
          this.sort_1 = s1s2.s1;
          this.sort_2 = s1s2.s2;
        }
      }

      this.get_rank_data(this.sort_1, this.sort_2);
    },

    sort1(tag1) {
      this.sort_1 = tag1;
      this.sort_2 = 1;

      this.get_rank_data(this.sort_1, this.sort_2);
    },
    sort2(tag2) {
      this.sort_2 = tag2;

      this.get_rank_data(this.sort_1, this.sort_2);
    },

    get_rank_data(s1, s2) {
      this.$store.commit("set_rank_s1s2", { s1: s1, s2: s2 });
      
      //取缓存数据
      var rankData = this.getCacheData(s1, s2);
      if (rankData) {
          this.ary = this.process_rank(rankData);
          return true;
      }

      // 加载
      this.$loading("加载...");
      var self = this;
      self.get({
          url: "/App/GetRank/?s1=" + s1 + "&s2=" + s2,
          success: function(data) {
              self.$loading.close();
              self.updateHttpCache(s1, s2, data);

              //处理数据---头像数据和神秘人
              self.ary = self.process_rank(data);
          }
      });
    },

    //启用store中排行榜的数据
    getCacheData(s1, s2) {
      var rnt_data = "";

      var rankType = "score";
      if (s1 == 2) {
        rankType = 'coin';
      }

      //最终是要拼接出这个key：rank_score_1
      //var http_Key = `rank_${rankType}_${s2}`;
      var http_Key = "rank_"+rankType+"_" + s2;


      // 获取缓存中的排行榜数据
      var http_cache = this.$store.state.http_cache;
      var rankData = http_cache[http_Key];

      var dtm = rankData.dtm;
      var dtmNow = new Date().getTime();
      var timeDiff = (dtmNow - dtm) / 1000; // 相差时间
      // console.log("缓存时长:"+timeDiff);
      if ( s2 == 1) {
        if (timeDiff < 30) {
          rnt_data = rankData.data_serve;
        }
      }else {
        if (timeDiff < 300) {
            rnt_data = rankData.data_serve;
        }
      }
      
      return rnt_data;
    },

    //处理豪气与魅力榜的缓存数据
    updateHttpCache(s1, s2, data) {
      var obj = {
          dtm: new Date().getTime(),
          data_serve: data
      };

      var rankType = "score";
      if (s1 == 2) {
        rankType = 'coin';
      }

      //最终是要拼接出这个key：rank_score_1
      var http_Key = "rank_"+rankType+"_" + s2;
      //var http_Key = `rank_${rankType}_${s2}`;
      var http_obj= {};
      http_obj[http_Key] = obj;

      this.$store.commit("set_http_cache", http_obj);

      if(s1 == 1 && s2 == 1) {
        this.$store.commit("set_http_cache", {index_rank1: obj});
      }
      if(s1 == 2 && s2 == 1) {
        this.$store.commit("set_http_cache", {index_rank2: obj});
      }
        
    },

    //处理排行榜头像
    process_rank(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].xh = i + 1;
        data[i].photo2 = this.$store.state.url + "/photo/" + data[i].photo;
        //隐身处理
        if (data[i].set_bord == 1) {
          data[i].photo2 = this.$store.state.url + "/photo/0.png";
          data[i].nick = "神秘人";
        }
      }
      return data;
    },

    goto_topic(item) {
      //console.log(JSON.stringify(item));
      if(item.set_bord == 1){
         this.$toast.center("此用户已设置了隐身，不要再戳了");
         return false;
      }
      var uid = item.uid;
      this.$router.push({ name: "home_page", params: { topic_uid: uid } });
    },

    rules() {
      var self = this;
      var h =
        '<div class="rank-rules">' +
        '<p class="txt">' + "该奖励，只针对魅力榜日榜<br>对今日上榜用户进行奖励，奖励规则如下</p>" +
        '<div class="line"></div>' +
        '<p class="txt">' +
        "日榜第<span class=" +'sp1>1</span>名，额外奖励<span class="sp2">30%</span>魅力值<br>' +
        "日榜第<span class=" +'sp1>2</span>名，额外奖励<span class="sp2">20%</span>魅力值<br>' +
        "日榜第<span class=" +'sp1>3</span>名，额外奖励<span class="sp2">18%</span>魅力值<br>' +
        "日榜第<span class=" +'sp1>4</span>名，额外奖励<span class="sp2">15%</span>魅力值<br>' +
        "日榜第<span class=" +'sp1>5</span>名，额外奖励<span class="sp2">10%</span>魅力值<br>' +
        "日榜第<span class=" +'sp1>6</span>名，额外奖励<span class="sp2">8%</span>魅力值<br>' +
        "日榜第<span class=" +'sp1>7</span>名，额外奖励<span class="sp2">6%</span>魅力值<br>' +
        "日榜第<span class=" +'sp1>8</span>名，额外奖励<span class="sp2">5%</span>魅力值<br>' +
        '<div class="line"></div>' +
        '<p class="tips">' + "&nbsp; &nbsp; &nbsp;实际到账奖励为全天24小时获得的魅力值总和为基数，奖励将会在次日经人工审核之后到账，默认公布在昨日榜上</p>" +
        '<p class="tips">' + "&nbsp; &nbsp; &nbsp; 特别说明，平台禁止一切作弊行为，请大家文明聊天，对于欺诈，恶意刷魅力等行为将严惩不贷！<br/><br/>活动最终解释权归小火柴平台所有。</p></div>";
      self.$refs.myConfirm.show(h, {
        type: "confirm",
        confirmText: "确定",
        titleText: "奖励规则",
        data: ""
      });
    },
  }
};
</script>
<style lang="scss">
.rank-rules {
  height:30rem;
  font-size:.9rem;
  overflow:scroll;
  border-radius:.3rem;
  .txt {
    line-height:1.8rem;
    text-align:center;
    margin:.8rem 0 .8rem 0;
    .sp1 {
      font-size:1.3rem;
      font-weight:bold;
      color:#e92162;
    }
    .sp2 {
      display:inline-block;
      width:3rem;
      font-size:1.3rem;
      text-align:center;
      font-weight:bold;
      color:#e92162;
    }
  }
  .line {
    border-top: 1px dashed #dcdcdc;
  }
  .tips1 {
    line-height:1.8rem;
    padding:.3rem;
    margin-top: 0.3rem;
  }

}
</style>
<style lang="scss" scoped>
.nav-right {
  padding-right: 0.1rem;
  .nav-lable {
    margin: 0;
    font-size: 0.9rem;
    color: #fff;
  }
}

.content {
  padding: 0.8rem;
  .up-name {
    height: 3rem;
    .rank-1 {
      width: 7rem;
      height: 2rem;
      line-height: 2rem;
      text-align: center;
      color: #666;
      font-weight: 600;
      font-size: 1.1rem;
      border-top-left-radius: 1rem;
      border-bottom-left-radius: 1rem;
      border: solid 1px #dcdcdc;
    }
    .rank-3 {
      width: 7rem;
      height: 2rem;
      line-height: 2rem;
      text-align: center;
      color: #666;
      font-weight: 600;
      font-size: 1.1rem;
      border-top-right-radius: 1rem;
      border-bottom-right-radius: 1rem;
      border: solid 1px #dcdcdc;
    }
    .rank-1-on {
      color: red;
      background-color: #ffde66;
      border: solid 1px #fcd137;
    }
  }
  .list {
    width: 60%;
  }
  .rank-2 {
      margin-top: 0.7rem;
      justify-content: space-around;
      .on {
        padding-bottom: 0.4rem;
        color: #e92162;
        border-bottom: solid 3px #e92162;
      }
    }
  .first {
    padding: 1.5rem 0 0.5rem 0;
    .one-img {
      width: 4rem;
      .ranking-img {
        width: 1.6rem;
        height: 2.3rem;
      }
    }
    .box {
      width: 11.5rem;
      height: 7.5rem;
      background-size: 100% 100%;
      background-image: url(../assets/img/头像框.png);
      img {
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        margin-top: 2.35rem;
      }
      
    }
    .nick {
      font-size: 1.15rem;
      font-weight: 600;
      color: #333;
    }
    .Howe {
      font-size: 1.25rem;
      font-weight: 600;
      color: rgb(186, 97, 255);
      line-height: 1.5rem;
    }
    .reward {
      font-size: 0.75rem;
      font-weight: 600;
      color: #999;
      line-height: 1.5rem;
    }
  }
  .ranking-img {
    width: 1.6rem;
    height: 2.3rem;
  }
  .number {
    font-size: 1.2rem;
    display: inline-block;
    width: 1.3rem;
    height: 2.3rem;
    line-height: 2.3rem;
    text-align: center;
    color: #666;
  }
  .pic-nick {
    padding: 0.5rem 0 0.5rem 0;
    margin-left: 0.8rem;
    color: #666;
    .pic {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
      margin-right: 1rem;
    }
  }
  .num {
    color: rgb(186, 97, 255);
    .reward2 {
      text-align: right;
      font-size: 0.75rem;
      color: #999;
    }
  }
  .menu-line {
    border-top: 1px solid #FFFFFF;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .content {
    .rank-1 {
      color: #DFDFDF;
      border: solid 1px #666;
    }
    .rank-3 {
      color: #DFDFDF;
      border: solid 1px #666;
    }
    .rank-1-on {
      color: #e92162;
      background-color: #ffde66;
      border: solid 1px #fcd137;
    }
    .rank-2 {
      color: #DFDFDF;
    }
    .nick {
      color: #FDFDFD;
    }
    .menu-line {
      border-top: 1px solid #404040;
    }
  }
}
</style>